// extracted by mini-css-extract-plugin
export default {"SkillArea":"EditSkills_SkillArea__aCGsF"};